import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=85131310&"
import script from "./TheFooter.vue?vue&type=script&lang=ts&"
export * from "./TheFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports